/**
 * @file bannerDebug.js
 * @description 首页 Banner 调试日志（仅非 production 环境输出）
 * @module features/home/utils/bannerDebug
 */

/**
 * @debug 首页 Banner 排查专用，上线前可整文件删除
 * @param {string} step
 * @param {...unknown} payload
 */
export function bannerDebug(step, ...payload) {
  if (process.env.NODE_ENV === 'production') return
  console.log(`[HomeBanner][${step}]`, ...payload)
}
